import React from "react";
import { createPortal } from "react-dom";
import { DashboardLoading } from "../../../../../CommonFunction/Loader";
import { formatDate } from "../../../../../CommonFunction/FormatedDate";

const NotificationModal = ({ messageOpen, closeMessage, messageById }) => {
  return createPortal(
   <>
      {messageOpen && (
        <div
          onClick={() => closeMessage()}
          className="font-avenir fixed inset-0 z-50 flex justify-center items-center bg-black bg-opacity-50 backdrop-blur-sm px-2"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-white rounded-md w-full max-w-[600px] max-h-[90vh] overflow-y-auto"
          >
            <div className="text-bgclr">
              {messageById?.length <= 0 ? (
                <div className="h-[320px] flex justify-center items-center">
                  <DashboardLoading />
                </div>
              ) : (
                <>
                  <div className="flex justify-between items-center font-semibold py-2 px-4 sm:px-5">
                    <h1 className="text-[18px]">Notice</h1>
                    <button
                      onClick={() => closeMessage()}
                      className="text-[20px]"
                    >
                      x
                    </button>
                  </div>
                  <hr className="shadow-md" />
                  <div className="flex gap-4 px-4 sm:px-5 pt-3">
                    <div className="font-semibold">
                      <img
                        src="https://cdn.clevdoc.com/assets/dashboard/user/user_avatar.png"
                        alt="N"
                        className="w-10 sm:w-12"
                      />
                    </div>
                    <div>
                      <h2 className="font-semibold text-[15px] sm:text-base">
                        {messageById?.bankDetails?.name}
                      </h2>
                      <p className="text-[13px] text-gray-400">
                        {messageById?.branchDetails?.b_id}, {messageById?.branchDetails?.name}
                      </p>
                    </div>
                  </div>
                  <div className="flex flex-wrap sm:flex-nowrap justify-between py-2 px-4 sm:px-5">
                    <div className="flex gap-2 flex-wrap">
                      <h2 className="font-semibold">{messageById?.title}</h2>
                      <p className="px-1.5 text-white bg-green-600 rounded-lg text-sm">
                        {messageById?.metadata?.type}
                      </p>
                      <div className="font-semibold text-sm">~{messageById?.metadata?.role}</div>
                    </div>
                    <p className="font-thin text-gray-600 text-sm mt-1 sm:mt-0">
                      {formatDate(messageById?.updatedAt)}
                    </p>
                  </div>
                  <div className="px-4 sm:px-5 pb-2 text-gray-500 text-sm">
                    {messageById?.body}
                  </div>
                  <div className="flex flex-col sm:flex-row border rounded-md text-gray-700 mx-4 sm:mx-5 my-2 py-3 px-4 sm:px-5 gap-4">
                    <div className="sm:w-1/2 sm:border-r sm:pr-5">
                      <h1 className="font-semibold text-[15px] sm:text-[16px] mb-1">
                        Loan Details:
                      </h1>
                      <div className="ml-1 sm:ml-3 mt-1 text-[14px] space-y-1">
                        <p>
                          Loan no.: <span>{messageById?.loanDetails?.identity_number}</span>
                        </p>
                        <p>
                          Loan Amt.: <span>Rs. {messageById?.loanDetails?.amount}</span>
                        </p>
                      </div>
                    </div>
                    <div className="sm:w-1/2">
                      <h1 className="font-semibold text-[15px] sm:text-[16px] mb-1">
                        Branch Details:
                      </h1>
                      <div className="ml-1 sm:pl-6 mt-1 text-[14px] space-y-1">
                        <p>
                          Branch ID: <span>{messageById?.branchDetails?.b_id}</span>
                        </p>
                        <p>
                          Phone no.: <span>{messageById?.branchDetails?.phone_number}</span>
                        </p>
                        <p>
                          Address:{" "}
                          <span>{messageById?.branchDetails?.address?.address}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </>,
    document.getElementById("portal")
  );
};

export default NotificationModal;
